import OgImage from '@propertypal/shared/src/resources/images/mobile-apps/apps-opengraph.jpg';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';
import FeatureBoxesSection from '../components/mobile-apps/FeatureBoxesSection';
import FeaturesPointsSection from '../components/mobile-apps/FeaturesPointsSection';
import MobileAppsHeaderSection from '../components/mobile-apps/MobileAppsHeaderSection';

const metaData = {
  title: 'PropertyPal Mobile Apps',
  description:
    "We know you deserve the best. Introducing our beautiful iPhone and Android apps for PropertyPal with all the features you've been waiting for. For free.",
  url: `/mobile-apps`,
};

const MobileAppPage = () => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: metaData.title,
          description: metaData.description,
          url: metaData.url,
          image: {
            url: OgImage.src,
            width: 1200,
            height: 650,
          },
        })}
      </Head>

      <MobileAppsHeaderSection />

      <FeatureBoxesSection />

      <FeaturesPointsSection />
    </>
  );
};

export default MobileAppPage;
